import type { Namespace, ParseKeys, TFunction } from 'i18next'
import type { ZodObject, ZodRawShape, ZodTypeAny, z } from 'zod'

export function createGetFieldLabelFactory<
  TSchema extends ZodObject<TSchemaShape, 'strip', ZodTypeAny, TModel>,
  TSchemaShape extends ZodRawShape,
  TModel = z.infer<TSchema>,
  TKey = keyof TSchemaShape,
>(_: TSchema, translationRootPath: string) {
  return <TNamespace extends Namespace>(t: TFunction<TNamespace>) =>
    (fieldName: TKey) => {
      const label = t(
        `${translationRootPath}.${fieldName}` as ParseKeys<TNamespace>
      )

      return typeof label === 'string' ? label : 'Field'
    }
}
